import { environment } from '@env/environment';
import { ErrorPageRoutes } from '@lib/interfaces';

/**
 * 共通のRoutes定義
 */
const COMMON = 'common' as const;
export const RoutesCommon = {
  /** 共通パス */
  COMMON: COMMON,
  /** 共通エラー画面 */
  SERVICE_ERROR: `${COMMON}/${ErrorPageRoutes.SERVICE}`,
  /** システムエラー画面 */
  SYSTEM_ERROR: `${COMMON}/${ErrorPageRoutes.SYSTEM}`,
  /** セッションタイムアウトエラー画面 */
  SESSION_TIMEOUT_ERROR: `${COMMON}/${ErrorPageRoutes.SESSION_TIMEOUT}`,
  /** ブラウザバックエラー画面 */
  BROWSER_BACK_ERROR: `${COMMON}/${ErrorPageRoutes.BROWSER_BACK}`,
} as const;

// FIXME: 各APPごとに指定する
/**
 * チェックインのテストページのパス
 */
export const TEST_ROUTES = {
  TEST_TO: 'test-to',
} as const;

export const CHECKIN_ROUTES = {
  /** チェックイン検索 */
  checkinSearch: 'checkin-search',
  /** チェックイン対象選択 */
  checkinSelect: 'checkin-select',
  /** チェックイン搭乗者情報入力 */
  passengerInput: 'passenger-input',
  /** チェックインシートマップ */
  seatmap: 'seatmap',
  /** チェックイン確認 */
  checkinReview: 'checkin-review',
  /** チェックイン完了　*/
  checkinCompleted: 'checkin-completed',
  /** チェックイン状況詳細　*/
  checkinMybooking: 'checkin-mybooking',
  /** 空港空席待ち人数照会結果　*/
  waitingSearch: 'waiting-search',
  /** 空港空席待ち人数照会結果　*/
  waitingNumber: 'waiting-number',
  /** 空席待ち照会結果　*/
  standbyFlightAvailability: 'standby-flight-availability',
  /** エントリー内容確認　*/
  standbyReview: 'standby-review',
  /** 空席待ちエントリー完了　*/
  standbyCompleted: 'standby-completed',
} as const;

/**
 * チェックインのベースパス定義
 * 相対パスにするため先頭のスラッシュを削除しておく
 */
const CHECKIN_BASE_PATH = environment.spa.app.cki
  .split('/')
  .filter((path) => path)
  .join('/');

/**
 * チェックインのパス定義
 * 共通エラー画面の確認ボタンの遷移先パス指定に使用している
 */
export const CHECKIN_PATH = {
  /** チェックイン状況詳細　*/
  checkinMybooking: `${CHECKIN_BASE_PATH}/${CHECKIN_ROUTES.checkinMybooking}`,
} as const;

/**
 * ServicingのRoutes定義
 */
export const SERVICING_ROUTES = {
  /** 予約詳細　*/
  mybooking: 'mybooking',
  /** 予約検索 */
  bookingSearch: 'booking-search',
} as const;

/**
 * ExchangeのRoutes定義
 */
export const EXCHANGE_ROUTES = {
  /** フライト検索　*/
  flightSearch: 'change-flight-search',
} as const;

// FIXME: 各APPごとに指定する
/**
 * 各画面のURL定義
 * @param ORGANIZATION_SELECT R02P011 ANA Biz組織選択
 * @param LOGIN R02P010 ANA Bizログイン画面
 * @param LOGOUT R02P012 ANA Bizログアウト
 */
export const RoutesResRoutes = {
  /** R02P011 ANA Biz組織選択 */
  ORGANIZATION_SELECT: 'organization-select',
  /** R02P010 ANA Bizログイン画面 */
  LOGIN: 'login',
  /** R02P012 ANA Bizログアウト */
  LOGOUT: 'logout',
} as const;

/**
 * プロモーションモードでローディング画面を表示する対象のRoutes指定
 * 提携では、ANA画像が表示されるためプロモーションローディングは使用しない
 */
export const LOADING_MODE_PROMOTION_ROUTES: string[] = []; // 例：RoutesHelloWorld.TEST
